import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { translate, titleConvert, classConvert, menuEntrys } from '../../assets/js/functions';
import IcoBack from "../../assets/img/ico-tornar.svg";
import IcoMenu from "../../assets/img/ico-menu-cuidar.svg";
import IcoTancar from "../../assets/img/ico-tancar.svg";


export default function ViewHeader({ group, index, expand, galleryOpen }) {

    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <>
        {menuOpen?
        <>
        <div className="mobile-nav w-100 is-hidden-tablet is-flex is-justify-content-space-between is-align-items-center px-7 py-5">
            <Link to={'/home'} className="is-invisible">
                    <img loading="lazy" src={IcoBack} alt={translate('Tornar a la portada')} width="47" height="34" className="is-block"/>
            </Link>
            <span className="is-block is-family-secondary is-lowercase is-size-3">{translate('Menú')}</span>
            <button type="button" className="button is-text is-paddingless" onClick={(event => {event.preventDefault();setMenuOpen(false)})}>
                <img loading="lazy" src={IcoTancar} alt={translate('Tancar el menú')} width="43" height="43"/>
            </button>
        </div>
        <div className="mobile-nav-container">
            <nav className="main-nav is-hidden-tablet mt-8 mx-auto">
                <ul className="is-flex is-flex-direction-column gap-5 is-align-items-center is-lowercase has-text-centered">
                    {menuEntrys().map(value =>
                    <li key={value}>
                        <Link to={'/'+value} class={"has-text-black is-block is-family-secondary radius-large is-size-4 px-8 py-2 "+classConvert(value)} aria-current={(group === value)?'page':''} >{titleConvert(value)}</Link>
                    </li>
                    )}
                </ul>
            </nav>
        </div>
        </>
        :
        <>
        <Link to={'/home'} className="home-link is-lowercase is-flex is-align-items-center gap-2 px-5 py-4 has-background-white has-text-black has-text-weight-black link-dn is-size-11 is-hidden-mobile">

        <img loading="lazy" src={IcoBack} alt="" width="47" height="34" className="is-flex-shrink-0"/>
            {translate('Torna a la portada')}
        </Link>
        <div className={"mobile-nav w-100 is-hidden-tablet is-flex is-justify-content-space-between is-align-items-center px-7 py-5 "+classConvert(group)+((expand || galleryOpen)?' mobile-nav--radius':'')}>
            <Link to={'/home'} className={(expand || galleryOpen)?'is-invisible':''}>
                <img loading="lazy" src={IcoBack} alt={translate('Torna a la portada')} width="47" height="34" className="is-block"/>
            </Link>
            <h1 className="is-family-secondary is-lowercase is-size-3">{titleConvert(group)}</h1>

            {(expand || galleryOpen)?
            <Link to={galleryOpen?('/'+group+'/'+index+'/declarations'):('/'+group+'/'+index)} type="button" className="button is-text is-paddingless">
                <img loading="lazy" src={IcoTancar} alt={translate('Tancar')} width="43" height="43"/>
            </Link>
            :
            <button type="button" className="button is-text is-paddingless" onClick={(event => {event.preventDefault();setMenuOpen(true)})}>
                <img loading="lazy" src={IcoMenu} alt={translate('Obrir el menú')} width="43" height="43"/>
            </button>
            }
        </div>
        </>
        }
        </>
    )
}
